import React, { Fragment, Component } from "react";
import {
  Container,
  Row,
  Col,
  CardBody,
  Card,
  CardTitle,
  CardSubtitle,
  Label,
  Button,
  Collapse,
  Table,
  Tooltip,
  Badge,
  Modal,
} from "reactstrap";
import { ConfirmAlert } from "../../../../helpers/ui/alert";
import { FileInput, generateFormData } from "../../../../helpers/ui/FileInput";
import {
  AvForm,
  AvGroup,
  AvInput,
  AvField,
  AvCheckboxGroup,
  AvCheckbox,
} from "availity-reactstrap-validation";
import Select from "react-select";

import { Link, useHistory, Redirect } from "react-router-dom";
import apiResponse from "../../../../services/apiResponse";
import CreateBloc from "./Blocs/CreateBloc";
import { accessRole } from "../../../../helpers/access_role";
import CustomSelect from "../../../../helpers/ui/CustomSelect";
import CreateModal from "./Components/CreateModal";
import moment from "moment";
import Shimmer from "react-shimmer-effect";
import EstimationCPNS from "./Components/EstimationCPNS";
import TableCandidateComponent from "./Components/TableCandidateComponent";
import UploadComponent from "./Components/UploadComponent";

class IndexView extends Component {
  createBloc = new CreateBloc();
  queryParams = new URLSearchParams(window.location.search);

  confirmInfo = "Apakah anda yakin akan menyimpan data ini?";
  successInfo = "Data berhasil disimpan";
  confirm_type = 1;

  constructor(props) {
    super(props);
    this.state = {
      dataForm: {},
      detailUuid: null,
      deleteUuid: null,
      period: null,
      modal: false,
      listCandidate: [],
      totalCandidate: 0,
      loadingTable: true,
      collectiveDecree: null,
      showTable: true,
      showUpload: false,
      modalSize: "sm",
    };
    this.tablePrimary = React.createRef();
  }

  setModalSize = (size) => {
    this.setState({
      modalSize: size,
    });
  };

  closeModal = (reload = false) => {
    this.setState({
      showUpload: false,
    });
    setTimeout(() => {
      this.setState({
        modalSize: "sm",
      });
    }, 500);
    if (reload) {
      this.setState(
        {
          showTable: false,
        },
        function () {
          setTimeout(() => {
            this.setState({
              showTable: true,
            });
          }, 100);
        }
      );
    }
  };

  toggle = () => {
    this.setState({ modal: !this.state.modal });
  };

  handleReloadTableCandidate = () => {
    this.tablePrimary.current.setTokenAPI();
  };

  handleDetailProps = (uuid) => {
    this.setState({
      detailUuid: uuid,
    });
  };

  handleTotalCandidate = (total) => {
    this.setState({
      totalCandidate: total,
    });
  };

  reformatOptions = (raw, label, value) => {
    return raw.map(function (data) {
      var newObj = {};
      newObj["label"] = data[label];
      newObj["value"] = data[value];

      return newObj;
    });
  };

  dateParse = (input) => {
    let res = "";
    if (input != "" && input != null) {
      res = moment(input).format("DD/MM/YYYY");
    }
    return res;
  };

  dateParseId = (input) => {
    let res = "";
    if (input != "" && input != null) {
      res = moment(input).locale("id-id").format("DD MMMM YYYY");
    }
    return res;
  };

  addTableData = () => {
    this.toggle();
  };

  submitData = async () => {
    const formData = generateFormData(this.state.dataForm, ""); // 'document' disini adalah nama field FileInput. Jika ada lebih dari 1 file input, maka gunakan array. conth: ['document', 'foto']
    await this.createBloc.fetchCreateDecreeCollective(formData);
    //console.log(formData)
  };

  handlerOnSubmit = (e, values) => {
    e.preventDefault();
    this.confirmInfo = "Apakah anda yakin akan menyimpan data ini?";
    this.confirm_type = 1;
    this.setState({
      dataForm: {
        ...values,
        period_uuid: this.queryParams.get("uuid"),
      },
      confirm: true,
    });
  };

  confirmResponse = (response) => {
    let forState = {};
    switch (response) {
      case "cancel":
        forState = {
          confirm: false,
        };
        break;
      case "confirm":
        forState = {
          loading: true,
          confirm: false,
        };

        // cek save or delete
        if (this.confirm_type == 1) {
          // save
          this.submitData();
        }

        break;
      case "success":
        forState = {
          success: false,
          // redirect: true
        };
        break;
      case "failed":
        forState = {
          failed: false,
        };
        break;
      default:
    }
    this.setState(forState);
  };

  componentDidMount() {
    this.createBloc.createDecreeCollectiveChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          if (result.data.status) {
            this.successInfo = "Data SK Kolektif berhasil disimpan";
            this.setState({
              loading: false,
              success: true,
            });
            this.createBloc.fetchDetailDecreeCollective({
              period_uuid: this.queryParams.get("uuid"),
            });
            this.handleReloadTableCandidate();
          } else {
            this.setState({
              loading: false,
              message: result.data.message,
              failed: true,
            });
          }

          break;
        case apiResponse.ERROR:
          this.setState({
            loading: false,
            failed: true,
          });
          break;
        default:
          break;
      }
    });

    this.createBloc.detailChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          if (result.data.status) {
            let response = result.data.response;
            //console.log(response)
            this.setState({
              period: response,
            });
          }
          break;
        case apiResponse.ERROR:
          break;
        default:
          break;
      }
    });

    this.createBloc.detailDecreeCollectiveChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          if (result.data.status) {
            let response = result.data.response;
            console.log(response);
            this.setState({
              collectiveDecree: response,
            });
          }
          break;
        case apiResponse.ERROR:
          break;
        default:
          break;
      }
    });

    this.createBloc.downloadSKCollectiveChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.LOADING:
          this.setState({
            loading: true,
          });
          break;
        case apiResponse.COMPLETED:
          const link = result.data.response;
          window.open(link.file_url, "_blank");
          //window.location.href = link.file_url
          this.setState({
            loading: false,
            success: true,
          });
          setTimeout(() => {
            this.setState({
              success: false,
            });
          }, 1000);
          break;
        case apiResponse.ERROR:
          this.setState({
            urlFileDetail: link,
            loading: false,
            failed: true,
          });
          setTimeout(function () {
            this.setState({
              failed: false,
            });
          }, 1000);
          break;
        default:
          break;
      }
    });

    this.createBloc.fetchDetailPeriod({ uuid: this.queryParams.get("uuid") });
    this.createBloc.fetchDetailDecreeCollective({
      period_uuid: this.queryParams.get("uuid"),
    });
  }

  componentWillUnmount() {
    this.createBloc.createDecreeCollectiveChannel?.unsubscribe();
    this.createBloc.detailChannel?.unsubscribe();
    this.createBloc.detailDecreeCollectiveChannel?.unsubscribe();
    this.createBloc.downloadSKCollectiveChannel?.unsubscribe();
  }

  render() {
    return (
      <Fragment>
        <Container fluid>
          <Row>
            <Col className="col-12">
              <EstimationCPNS
                uuid={this.queryParams.get("uuid")}
                periodMonth={
                  this.state.period != null
                    ? moment()
                        .month(this.state.period.cpns_period_month - 1)
                        .locale("id-id")
                        .format("MMMM")
                    : "-"
                }
                periodYear={
                  this.state.period != null
                    ? this.state.period.cpns_period_year
                    : "-"
                }
              />
            </Col>

            <Col className="col-12">
              <Card>
                <CardBody>
                  <CardTitle>Input Kolektif CPNS</CardTitle>
                  <CardSubtitle className="mb-3"></CardSubtitle>
                  <hr />

                  <AvForm
                    className="needs-validation"
                    onValidSubmit={(e, values) =>
                      this.handlerOnSubmit(e, values)
                    }
                  >
                    <Row className="mb-3">
                      <Label className="col-md-2 col-form-label">
                        Nomor SK <span className="text-danger">*</span>
                      </Label>
                      <Col md="2">
                        <AvField
                          name="cpns_collective_decree_number"
                          placeholder="Nomor SK"
                          errorMessage="Masukkan Nomor SK"
                          type="text"
                          className="form-control"
                          value={
                            this.state.collectiveDecree
                              ?.cpns_collective_decree_number
                          }
                          validate={{ required: { value: true } }}
                          disabled={
                            this.state.collectiveDecree != null ? true : false
                          }
                        />
                      </Col>
                    </Row>

                    <Row className="mb-3">
                      <Label className="col-md-2 col-form-label">
                        Tanggal SK <span className="text-danger">*</span>
                      </Label>
                      <Col md="2">
                        <AvField
                          name="cpns_collective_decree_date"
                          placeholder="Tanggal SK"
                          errorMessage="Masukkan Tanggal SK"
                          type="date"
                          className="form-control"
                          value={
                            this.state.collectiveDecree
                              ?.cpns_collective_decree_date
                          }
                          validate={{ required: { value: true } }}
                          disabled={
                            this.state.collectiveDecree != null ? true : false
                          }
                        />
                      </Col>
                    </Row>

                    <Row className="mb-3">
                      <Label className="col-md-2 col-form-label">
                        TMT SK <span className="text-danger">*</span>
                      </Label>
                      <Col md="2">
                        <AvField
                          name="cpns_collective_decree_tmt_date"
                          placeholder="TMT SK"
                          errorMessage="Masukkan TMT SK"
                          type="date"
                          className="form-control"
                          value={
                            this.state.collectiveDecree
                              ?.cpns_collective_decree_tmt_date
                          }
                          validate={{ required: { value: true } }}
                          disabled={
                            this.state.collectiveDecree != null ? true : false
                          }
                        />
                      </Col>
                    </Row>

                    {this.state.collectiveDecree != null && (
                      <Row className="mb-3">
                        <Label className="col-md-2 col-form-label">
                          Download SK Kolektif
                        </Label>
                        <Col md="2">
                          <Button
                            className="btn btn-sm btn-success"
                            onClick={() => {
                              this.createBloc.fetchDownloadSKCollective({
                                uuid: this.state.collectiveDecree
                                  ?.cpns_collective_decree_uuid,
                              });
                            }}
                          >
                            Download <i className="fa fa-download ms-1"></i>
                          </Button>
                        </Col>
                      </Row>
                    )}

                    <hr />

                    <Row className="mb-3">
                      <Col md="12" className="d-flex mb-3">
                        <div>
                          <b>
                            Total Peserta CPNS :{" "}
                            <Badge className="rounded-pill bg-success font-size-12">
                              {" "}
                              {this.state.totalCandidate}{" "}
                            </Badge>
                          </b>
                        </div>
                        {this.state.collectiveDecree == null && (
                          <>
                            <div className="ms-auto">
                              <Button
                                className="me-2"
                                color="success"
                                onClick={() =>
                                  this.setState({ showUpload: true })
                                }
                              >
                                Import <i className="uil uil-upload-alt"></i>{" "}
                              </Button>
                              <Button
                                color="primary"
                                onClick={() => this.addTableData()}
                              >
                                Tambah <i className="uil uil-plus"></i>{" "}
                              </Button>
                            </div>
                          </>
                        )}
                      </Col>

                      <hr />

                      <Col md="12">
                        <TableCandidateComponent
                          ref={this.tablePrimary}
                          periodUuid={this.queryParams.get("uuid")}
                          detail={this.handleDetailProps}
                          totalCandidate={this.handleTotalCandidate}
                        />
                      </Col>
                    </Row>

                    <hr />

                    <Row>
                      <Col md="9">
                        <Link to="/kepegawaian/cpns.html">
                          <Button color="danger">
                            <i className="uil-arrow-left"></i> Kembali
                          </Button>
                        </Link>{" "}
                        {this.state.collectiveDecree == null && (
                          <Button color="success" type="submit">
                            <i className="uil-arrow-up-right"></i> Submit Data
                          </Button>
                        )}
                      </Col>
                    </Row>
                  </AvForm>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>

        <CreateModal
          modal={this.state.modal}
          toggle={() => this.toggle()}
          periodUuid={this.state.period?.cpns_period_uuid}
          // uuid={this.state.uuid}
          setDetailUuid={(value) => this.handleDetailProps(value)}
          handleReload={this.handleReloadTableCandidate}
          detailUuid={this.state.detailUuid}
        />

        <Modal
          size={this.state.modalSize}
          isOpen={this.state.showUpload}
          /* toggle={() => {
                        this.setState({
                            showUpload: !this.state.showUpload,
                        })
                        setTimeout(() => {
                            this.setState({
                                modalSize: 'sm'
                            })
                        }, 500);
                    }} */
        >
          <div className="modal-header">
            <h5 className="modal-title mt-0" id="myLargeModalLabel">
              Import Data CPNS
            </h5>
            <button
              onClick={() => {
                this.setState({
                  showUpload: false,
                });
                setTimeout(() => {
                  this.setState({
                    modalSize: "sm",
                  });
                }, 500);
              }}
              type="button"
              className="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div className="modal-body">
            <UploadComponent
              handleSetModalSize={this.setModalSize}
              handleCloseModal={this.closeModal}
              periodUuid={this.state.period?.cpns_period_uuid}
              handleReload={this.handleReloadTableCandidate}
            />
          </div>
        </Modal>

        <ConfirmAlert
          confirmTitle="Konfirmasi!"
          confirmInfo={this.confirmInfo}
          loadingTitle="Mengirim data..."
          loadingInfo="Tunggu beberapa saat"
          successTitle="Berhasil!"
          successInfo={this.successInfo}
          failedTitle="Gagal!"
          failedInfo={this.state.message ?? "Data gagal disimpan"}
          showConfirm={this.state.confirm}
          showLoading={this.state.loading}
          showSuccess={this.state.success}
          showFailed={this.state.failed}
          response={this.confirmResponse}
        />
        {this.state.redirect ? <Redirect to="/kepegawaian/cpns.html" /> : null}
      </Fragment>
    );
  }
}

export default IndexView;
